var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdoorTableColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.45,
    y: 239.804,
    style: {
      fill: "#CE4500"
    },
    width: 491.102,
    height: 71.052
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.817,
    y: 92.474,
    style: {
      fill: "#CE4500"
    },
    width: 337.502,
    height: 96.131
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED732F"
    },
    points: "181.07,239.805 212.115,188.604 150.466,188.604 119.421,239.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED732F"
    },
    points: "76.34,310.857 10.45,419.527 72.099,419.527 137.989,310.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED732F"
    },
    points: "392.58,239.805 361.535,188.604 299.886,188.604 330.931,239.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED732F"
    },
    points: "374.013,310.857 439.903,419.527 501.552,419.527 435.661,310.857  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.589,229.356h-0.137c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449h0.137 c5.771,0,10.449-4.678,10.449-10.449S262.36,229.356,256.589,229.356z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.001,310.857v-71.052c0-5.771-4.678-10.449-10.449-10.449H398.464l-18.374-30.303h46.228 c5.771,0,10.449-4.678,10.449-10.449V92.474c0-5.771-4.678-10.449-10.449-10.449H367.27c-5.771,0-10.449,4.678-10.449,10.449 c0,5.771,4.678,10.449,10.449,10.449h48.6v75.233H99.266v-75.233h202.342c5.771,0,10.449-4.678,10.449-10.449 c0-5.771-4.678-10.449-10.449-10.449H88.817c-5.771,0-10.449,4.678-10.449,10.449v96.131c0,5.771,4.678,10.449,10.449,10.449h43.094 l-18.373,30.303H10.45c-5.771,0-10.449,4.678-10.449,10.449v71.052c0,5.771,4.678,10.449,10.449,10.449h47.335L1.515,414.11 c-1.957,3.226-2.022,7.257-0.17,10.544c1.852,3.287,5.332,5.322,9.105,5.322h61.649c3.653,0,7.041-1.908,8.935-5.031l62.839-103.638 h224.256l62.839,103.638c1.894,3.124,5.282,5.031,8.935,5.031h61.649c3.773,0,7.253-2.034,9.104-5.322 c1.852-3.287,1.787-7.318-0.17-10.544l-56.269-92.804h47.335C507.323,321.306,512.001,316.628,512.001,310.857z M355.652,199.053 l18.374,30.303h-37.209l-18.375-30.303H355.652z M156.35,199.053h37.21l-18.373,30.303h-37.21L156.35,199.053z M66.215,409.078 h-37.21l53.22-87.771h37.21L66.215,409.078z M482.996,409.078h-37.21l-53.219-87.771h37.21L482.996,409.078z M491.103,300.409 H20.899v-50.154h201.749c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449h-23.022l18.373-30.303h76.004 l18.375,30.303h-23.023c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449h201.749V300.409z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.413,102.923h0.137c5.771,0,10.449-4.678,10.449-10.449c0-5.771-4.678-10.449-10.449-10.449h-0.137 c-5.771,0-10.449,4.678-10.449,10.449C324.964,98.245,329.642,102.923,335.413,102.923z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorTableColor);
export default __webpack_public_path__ + "static/media/outdoor_table_color.55410abaad291fdfa506f1631bb704d3.svg";
export { ForwardRef as ReactComponent };